// The comparison's five dispositions in words, in a module of their own so a
// page that only shows a comparison row's pill does not import the Comparison
// page (#1461). An access point's page (devices/Reach.tsx) imported
// DISPOSITION from Comparison.tsx, and DeviceDetail is in the main chunk, so the
// whole Comparison page rode in the main chunk with it; #1461's growth put that
// chunk 0.3 kB over #201's limit (scripts/bundle-size.mjs).
import type { components } from "../api/schema";
import { listed, unrecognized } from "../api/openEnum";

type Disposition = components["schemas"]["ComparisonDisposition"];

/** The five, each with the word a pill shows and its tone (§18: always a word
 * beside the colour). The typecheck forces every disposition a label. */
export const DISPOSITION: Record<Disposition, { label: string; tone: "good" | "warn" | "serious" | "info" | "none" }> = {
  agree: { label: "agree", tone: "good" },
  differs: { label: "differs", tone: "serious" },
  only_in_plan: { label: "only in plan", tone: "info" },
  only_in_estate: { label: "only in estate", tone: "warn" },
  unanswered: { label: "unanswered", tone: "none" },
};

/** A row's disposition in words: the five's, or the value as received and marked unrecognized,
 * since a row's disposition is the five or any other string (ADR-0511 5a). */
export function dispositionOf(d: string): { label: string; tone: "good" | "warn" | "serious" | "info" | "none" } {
  return listed(DISPOSITION, d) ? DISPOSITION[d] : { label: unrecognized(d), tone: "warn" };
}
